module.exports = "/images/down.svg?1f8b60d07a97c0c2d2bfb8e38598b805";